import { baseurlv2HttpRequest } from '../../../../service';
export const validateOtp = (payload, signal) => {
    return baseurlv2HttpRequest({
        url: '/customers/validate-otp',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: payload,
        signal,
    });
};
//# sourceMappingURL=validateOtp.js.map